// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2zwf1","error":"Textarea_error__1NxBb","readonly":"Textarea_readonly__1hsZ4","disabled":"Textarea_disabled__279S_"};